import {
  DxChart,
  DxSeries,
  DxCommonSeriesSettings,
  DxLabel,
  DxFormat,
  DxLegend,
  DxExport,
} from 'devextreme-vue/chart';

/*
Example: dataOptions: {"title":"Λ. ΛΕΙΒΑΔΙΩΤΗΣ & ΥΙΟΙ ΛΤΔ",
"subtitle":"Avg: 127.93",
"dataOptions":[{"valueField":"1/2023","name":"1/2023"},
{"valueField":"4/2022","name":"4/2022"},
{"valueField":"3/2022","name":"3/2022"},
{"valueField":"2/2022","name":"2/2022"}]}

dataSource: [{"description":"","1/2023":31.41,"4/2022":265,"3/2022":26.3,"2/2022":189}]

*/
export default {
  name: "DxBarChart",
  props: {
    dataSource: {
      type: Array,
      required: true,
    },
    dataOptions: {
      type: Object,
      required: true,
    },
    enableExport: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    snackBar: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    DxChart,
    DxSeries,
    DxCommonSeriesSettings,
    DxLabel,
    DxFormat,
    DxLegend,
    DxExport,
  },
  data: () => ({}),
  created() {},
  methods: {
    onPointClick({ target }) {
      target.select();
      return;
    },
  },
};
